import * as Yup from 'yup';

export const initialValues = {
  agencyName: '',
};

export const validationSchema = Yup.object().shape({
  agencyName: Yup.object()
    .shape({
      id: Yup.number().required(),
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required('Agency name is a required field'),
});
